import type { AddUserFormData, FormErrors } from './addUserTypes';

const emptyFormErrors = (): FormErrors => ({
    email: '',
    password: '',
    firstName: '',
    lastName: '',
    customerId: '',
});

export function validateAddUserForm(formData: AddUserFormData, isEditMode: boolean): {
    isValid: boolean;
    errors: FormErrors;
} {
    const errors = emptyFormErrors();
    let isValid = true;

    if (formData.userType === 'External' && !formData.customerId) {
        errors.customerId = 'Please select a customer';
        isValid = false;
    }

    if (!formData.email.trim()) {
        errors.email = 'This field is required';
        isValid = false;
    }

    if (!formData.firstName.trim()) {
        errors.firstName = 'This field is required';
        isValid = false;
    }

    if (!formData.lastName.trim()) {
        errors.lastName = 'This field is required';
        isValid = false;
    }

    if (!formData.ssoEnabled && !formData.password.trim() && !isEditMode) {
        errors.password = 'This field is required';
        isValid = false;
    }

    return { isValid, errors };
}
